import { connect } from 'react-redux';
import {
	getLocationDetailsById,
	getLocationBuildingFloorsById,
	getBuildingFloorGeojson,
	getBuildingFloorNavNodes,
	getLocationAssetsByLocationId,
	resetPage,
	resetMeta,
	getLocaationIdByRemoteId
} from '../../actions/LocationDetailPage';
import LocationDetailPage from './LocationDetailPage';

const mapsStateToProps = state => ({
	pageProps: state.locationDetailPage.locationDetailPageReducer
	// mapPageProps: state.mapPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getLocationDetailsById(options) {
		dispatch(getLocationDetailsById(options));
	},
	getLocationBuildingFloorsById(options) {
		dispatch(getLocationBuildingFloorsById(options));
	},
	getLocaationIdByRemoteId(options) {
		dispatch(getLocaationIdByRemoteId(options));
	},
	getBuildingFloorGeojson(options) {
		dispatch(getBuildingFloorGeojson(options));
	},
	getBuildingFloorNavNodes(options) {
		dispatch(getBuildingFloorNavNodes(options));
	},
	getLocationAssetsByLocationId(options) {
		dispatch(getLocationAssetsByLocationId(options));
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(LocationDetailPage);